import * as FeatherIcons from 'vue-feather-icons';

export default {
    items: [
        {
            name: 'Dashboard',
            type: 'dashboard',
            route: 'dashboard',
            color: 'navy',
            group: 'general',
            iconComponent: FeatherIcons.GridIcon,
        },
        {
            name: 'Content',
            children: [
                // { name: 'Layouts', route: 'layouts', type: 'layout', },
                { name: 'Pages', route: 'pages', type: 'page' },
                // { name: 'Panel library', route: 'panels', type: 'panel' },
            ],
            color: 'navy',
            group: 'general',
            iconComponent: FeatherIcons.LayersIcon,
        },
        {
            name: 'Assets',
            route: 'assets/0',
            type: 'asset',
            color: 'navy',
            group: 'general',
            iconComponent: FeatherIcons.ImageIcon,
        },
        {
            name: 'Customers',
            children: [
                { name: 'Customers', route: 'customers', type: 'customer' },
                { name: 'Logins', route: 'customer_logins', type: 'customer_login' },
                { name: 'Login Reports', route: 'login_reports', type: 'login_report' },
                { name: 'Pending Registrations', route: 'customer_logins?filter=approved:0', type: 'customer_login' },
            ],
            color: 'navy',
            group: 'client',
            iconComponent: FeatherIcons.UsersIcon,
        },
        {
            name: 'Trips',
            route: 'trips',
            type: 'trip',
            color: 'navy',
            group: 'client',
            iconComponent: FeatherIcons.MapPinIcon,
        },
        // {
        //     name: 'Enquiries',
        //     route: 'enquiries',
        //     type: 'enquiry',
        //     color: 'navy',
        //     group: 'client',
        //     iconComponent: FeatherIcons.MailIcon,
        // },
        {
            name: 'Notifications',
            color: 'navy',
            group: 'client',
            iconComponent: FeatherIcons.BellIcon,
            children: [
                { name: 'Notifications', route: 'notifications', type: 'notification' },
                { name: 'Contact groups', route: 'contact_groups', type: 'contact_group' },
            ]
        },
        {
            name: 'Accounts',
            children: [
                { name: 'Users', route: 'users', type: 'user' },
                { name: 'Roles', route: 'roles', type: 'role' },
            ],
            color: 'navy',
            group: 'settings',
            iconComponent: FeatherIcons.LockIcon,
        },
        {
            name: 'Settings',
            children: [
                { name: 'Settings', route: 'settings', type: 'setting' },
                { name: 'Redirect URLs', route: 'redirect_urls', type: 'redirect_url' },
            ],
            color: 'navy',
            group: 'settings',
            iconComponent: FeatherIcons.SettingsIcon,
        }
    ],
    defaultItem: 'Content',
}
